import { percent } from "csx";
import { Vertical } from "gls";
import { SidebarLabel } from "./SidebarLabel";
import { usePermissions } from "shared/hooks/usePermissions";

interface SidebarItemGroupProps {
  label: string;
  isCollapsed?: boolean;
  permissionName?: string;
}

export const SidebarItemGroup: FCWithChildren<SidebarItemGroupProps> = ({
  label,
  isCollapsed,
  children,
  permissionName,
}) => {
  if (permissionName != null && permissionName != undefined) {
    const { hasPermission } = usePermissions();

    if (!hasPermission(permissionName)) {
      return <></>;
    }
  }

  return (
    <Vertical spacing={0} width={percent(100)}>
      <SidebarLabel label={label} isCollapsed={isCollapsed} />
      <Vertical spacing={isCollapsed ? 0 : 10}>{children}</Vertical>
    </Vertical>
  );
};
